import React from 'react';
import { usePWA } from '../../hooks/usePWA';

/**
 * PWABanner — Componente que muestra:
 *  1. Banner de instalación  → "Instala la app en tu celular"
 *  2. Banner de actualización → "Hay una versión nueva, toca para actualizar"
 *
 * Úsalo en App.js así:
 *   import PWABanner from './components/common/PWABanner';
 *   // Dentro del return de App:
 *   <PWABanner />
 */
export default function PWABanner() {
  const { isInstallable, installApp, updateAvailable, applyUpdate } = usePWA();

  return (
    <>
      {/* ── Banner de ACTUALIZACIÓN ─────────────────────────────────────── */}
      {updateAvailable && (
        <div style={styles.updateBanner}>
          <span style={styles.updateIcon}>🔄</span>
          <span style={styles.updateText}>Nueva versión disponible</span>
          <button style={styles.updateBtn} onClick={applyUpdate}>
            Actualizar ahora
          </button>
        </div>
      )}

      {/* ── Banner de INSTALACIÓN ───────────────────────────────────────── */}
      {isInstallable && !updateAvailable && (
        <div style={styles.installBanner}>
          <div style={styles.installLeft}>
            <span style={styles.installIcon}>📲</span>
            <div>
              <div style={styles.installTitle}>Instalar Control Campo</div>
              <div style={styles.installSubtitle}>
                Trabaja offline sin perder información
              </div>
            </div>
          </div>
          <button style={styles.installBtn} onClick={installApp}>
            Instalar
          </button>
        </div>
      )}
    </>
  );
}

// ─── Estilos inline (sin dependencia de CSS externo) ─────────────────────────
const styles = {
  // Banner de actualización — barra fija arriba, azul oscuro
  updateBanner: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 9999,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '12px',
    padding: '10px 16px',
    background: 'linear-gradient(90deg, #1565c0, #1976d2)',
    color: '#fff',
    fontSize: '14px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.25)',
  },
  updateIcon: { fontSize: '18px' },
  updateText: { flex: 1, textAlign: 'center', fontWeight: 500 },
  updateBtn: {
    background: '#fff',
    color: '#1565c0',
    border: 'none',
    borderRadius: '20px',
    padding: '6px 16px',
    fontWeight: 700,
    cursor: 'pointer',
    fontSize: '13px',
    whiteSpace: 'nowrap',
  },

  // Banner de instalación — tarjeta flotante abajo
  installBanner: {
    position: 'fixed',
    bottom: '16px',
    left: '50%',
    transform: 'translateX(-50%)',
    zIndex: 9999,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '16px',
    padding: '14px 20px',
    background: '#fff',
    borderRadius: '16px',
    boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
    minWidth: '300px',
    maxWidth: '90vw',
  },
  installLeft: { display: 'flex', alignItems: 'center', gap: '12px' },
  installIcon: { fontSize: '28px' },
  installTitle: {
    fontWeight: 700,
    fontSize: '14px',
    color: '#0d1b2a',
  },
  installSubtitle: {
    fontSize: '12px',
    color: '#607d8b',
    marginTop: '2px',
  },
  installBtn: {
    background: 'linear-gradient(135deg, #1976d2, #42a5f5)',
    color: '#fff',
    border: 'none',
    borderRadius: '20px',
    padding: '8px 20px',
    fontWeight: 700,
    cursor: 'pointer',
    fontSize: '14px',
    whiteSpace: 'nowrap',
    boxShadow: '0 4px 12px rgba(25,118,210,0.35)',
  },
};
